import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {CustomerProfileStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/storefrontCustomerProfilesWorkspaceCapability/domain/StorefrontCustomerProfiles";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type StorefrontCustomerProfile = {
    id: Uuid;
    status: CustomerProfileStatus;
    revisionId: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    companyName?: string | null;
};

export const storefrontCustomerProfileValidator: zod.ZodType<StorefrontCustomerProfile> = zod.object({
    id: uuidZodValidator,
    status: zod.enum(CustomerProfileStatus),
    revisionId: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    fullName: zod.string().nullable().optional(),
    email: zod.string().nullable().optional(),
    phone: zod.string().nullable().optional(),
    companyName: zod.string().nullable().optional(),
});
